export const DATA_LAYER_CUSTOM_EVENT = 'DataLayerEvent'
